export default __webpack_public_path__ + "static/media/tt-5g.bf6e6604.png";